/**
 * User Blocking utilities.
 *
 * Blocked users are stored in currentUser.attributes.protectedData.blockedUsers[]
 * as an array of user UUIDs.
 *
 * Reporting a user stores reports in metadata on the reported user
 * (requires Integration API).
 */

/**
 * Get blocked user IDs for the current user.
 * @param {Object} currentUser — Sharetribe currentUser entity
 * @returns {string[]}
 */
export const getBlockedUsers = currentUser =>
  currentUser?.attributes?.protectedData?.blockedUsers || [];

/**
 * Check if the current user has blocked a specific user.
 * @param {Object} currentUser
 * @param {string} userId — UUID of the user to check
 */
export const isUserBlocked = (currentUser, userId) =>
  getBlockedUsers(currentUser).includes(userId);

/**
 * Build the updated protectedData after blocking/unblocking.
 * @param {Object} currentUser
 * @param {string} targetUserId
 * @param {boolean} block — true to block, false to unblock
 * @returns {{ blockedUsers: string[] }}
 */
export const toggleBlock = (currentUser, targetUserId, block) => {
  const current = getBlockedUsers(currentUser);

  const updated = block
    ? current.includes(targetUserId) ? current : [...current, targetUserId]
    : current.filter(id => id !== targetUserId);

  return { blockedUsers: updated };
};
